import { observer } from "mobx-react-lite";
import { Button, Center, Flex, FlexProps } from "@chakra-ui/react";

import { langStore, toolbarStore, translate, useSelecting } from "@noli/business";

import "./UploaderPanel.scss";
import { onArrange, useOwnToast } from "@/utils/misc";
import { Editor_Words } from "@/utils/lang/editor";

function UtilsPanel(props: FlexProps) {
  const t = useOwnToast();
  const lang = langStore.tgt;
  const { type, nodes } = useSelecting("raw");

  if (toolbarStore.inBrushMode) {
    return null;
  }
  if (type !== "none" && type !== "multiple") {
    return null;
  }

  return (
    <Flex w="100%" direction="column" {...props}>
      <Center my="24px">
        <Button w="80%" onClick={() => onArrange(t, lang, { type, nodes })} variant="outline">
          {translate(Editor_Words["auto-arrange"], lang)}
        </Button>
      </Center>
    </Flex>
  );
}

export default observer(UtilsPanel);
